export default {
  title: {
    create: 'Send',
    templates: 'Templates',
    payment: 'Funds',
    support: 'Support',
    jivosite: 'Support'
  }
}
